export default __webpack_public_path__ + "static/media/feedback_oops_02.2ba40400.png";